<template>
    <div class="assignment-answer">
        <div
            class="fill-in-the-blanks"
            v-if="canAnswer && editing">
            <design-2021-fill-in-the-blanks-component
                @update-answer="updateAnswer"
                :text="partIn.fill_in_the_blanks_text.text_with_blanks"
                :answers-in="answers"
            ></design-2021-fill-in-the-blanks-component>
        </div>

        <div
            class="assignment-unanswered"
            v-if="!editing">

            <design-2021-fill-in-the-blanks-component
                @update-answer="updateAnswer"
                :disabled="true"
                :text="partIn.fill_in_the_blanks_text.text_with_blanks"
                :answers-in="answers"
            ></design-2021-fill-in-the-blanks-component>
            <span
                v-if="!partIn.answers.length">{{ canAnswer ? $t('assignment.not_yet_answered') : $t('assignment.not_answered')
                }}</span>
        </div>

        <div class="answer-actions">
            <div class="button-group">
                <b-button
                    class="btn-save btn-save-answer"
                    v-if="editing"
                    variant="primary"
                    @click="onSave()">
                    Opslaan
                </b-button>

                <b-button
                    class="btn-assignment-answer"
                    v-if="canAnswer && !editing"
                    variant="primary"
                    @click="editing = true">
                    Beantwoorden
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-assignment-show-answer-question-component',
        props: ['partIn', 'canAnswer', 'projectId'],
        data() {
            return {
                editing: false,
                answers: this.partIn.answers[0] ? JSON.parse(this.partIn.answers[0]?.json.value) : {}
            };
        },
        methods: {
            onSave() {
                this.alert.saving();

                if (!this.partIn.hasAnswer()) {
                    // create

                    const data = {
                        value: this.answers,
                        part_id: this.partIn.id,
                        project_id: this.projectId
                    };

                    this.axios.post(this.routes.assignmentAnswer(), data).then(
                        (response) => {
                            this.partIn.addRelation('answers', response.data);

                            this.editing = false;
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        }
                    );
                } else {
                    // update

                    const data = {
                        value: this.answers
                    };

                    this.axios.post(this.routes.assignmentAnswerJsonUpdate(this.partIn.answers[0].json.id), data).then(
                        (response) => {
                            this.partIn.getAnswer().json.update(response.data);
                            this.editing = false;
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        }
                    );
                }
            },
            updateAnswer(answers) {
                this.answers = answers;
            }
        }
    };
</script>

<style scoped lang="scss">
    .assignment-answer {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');

        .btn-assignment-answer {
            line-height: 1;
        }
    }

    .assignment-unanswered {
        padding: map-get($grid-gutter-spacing, 'fifteen');
        color: $text-muted-color;
        border-radius: $border-radius-content;
        border: 1px solid $border-color;
    }

    .fill-in-the-blanks ::v-deep {
        div.ck-toolbar {
            border-top-left-radius: $border-radius-content !important;
            border-top-right-radius: $border-radius-content !important;
        }

        .ck.ck-editor__main {
            .ck.ck-content {
                border-top: 1px solid $border-color;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                background-color: $white;
            }
        }
    }

    .answer-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .word-count {
        display: flex;
        font-weight: $font-weight-medium;
    }

    .word-count-text {
        margin-right: map-get($grid-gutter-spacing, 'four');
    }

    .amount {
        color: var(--textColor);
    }

    .button-group {
        flex: 1 0 auto;
        align-self: flex-start;
    }
</style>
